import { css } from 'lit';

export const styles = css`
	:host {
		--_sds-checkbox-block-gap: var(--sds-checkbox-block-gap, var(--sds-spacing-4xs));
		--_sds-checkbox-inline-gap: var(--sds-checkbox-inline-gap, var(--sds-spacing-3xs));
		--_sds-checkbox-font-family: var(--sds-checkbox-font-family, var(--sds-typography-font-family-roboto));

		--_sds-checkbox-label-font-size: var(--sds-checkbox-label-font-size, var(--sds-components-font-size-content-md));
		--_sds-checkbox-label-font-weight: var(--sds-checkbox-label-font-weight, var(--sds-typography-body-md-desktop-font-weight));
		--_sds-checkbox-label-line-height: var(--sds-checkbox-label-line-height, var(--sds-components-line-height-tall-content-md));
		--_sds-checkbox-label-text-color: var(--sds-checkbox-label-text-color, var(--sds-text-default, var(--sds-color-neutral-text-default)));

		--_sds-checkbox-input-background-color: var(--sds-checkbox-input-background-color, var(--sds-color-surface-default, var(--sds-color-neutral-surface-default)));
		--_sds-checkbox-input-border-color: var(--sds-checkbox-input-border-color, var(--sds-color-border-default, var(--sds-color-neutral-border-default)));
		--_sds-checkbox-input-border-width: var(--sds-checkbox-input-border-width, var(--sds-border-md));
		--_sds-checkbox-input-border-radius: var(--sds-checkbox-input-border-radius, var(--sds-radius-xs));
		--_sds-checkbox-input-border-style: var(--sds-checkbox-input-border-style, solid);
		--_sds-checkbox-input-size: var(--sds-checkbox-input-width, var(--sds-components-icon-md));
		--_sds-checkbox-input-aspect-ratio: var(--sds-checkbox-input-aspect-ratio, 1);
		--_sds-checkbox-input-icon-color: var(--sds-checkbox-input-text-color, var(--sds-color-main-action-contrast-default));

		--_sds-checkbox-help-text-color: var(--sds-checkbox-help-text-color, var(--sds-color-text-subtle, var(--sds-color-neutral-text-subtle)));
		--_sds-checkbox-help-text-font-size: var(--sds-checkbox-help-text-font-size, var(--sds-components-font-size-content-md));
		--_sds-checkbox-help-text-font-weight: var(--sds-checkbox-help-text-font-weight, var(--sds-typography-body-md-desktop-font-weight));
		--_sds-checkbox-help-text-line-height: var(--sds-checkbox-help-text-line-height, var(--sds-components-line-height-squeezed-md));

		--_sds-checkbox-focus-color-outer: var(--sds-checkbox-focus-color-outer, var(--sds-color-states-focus-outer));
		--_sds-checkbox-focus-color-inner: var(--sds-checkbox-focus-color-inner, var(--sds-color-states-focus-inner));
		--_sds-checkbox-focus-spacing: var(--sds-checkbox-focus-spacing, var(--sds-color-states-focus-spacing));
		--_sds-checkbox-focus-radius: var(--sds-checkbox-focus-radius, var(--sds-radius-xs));

		--_sds-checkbox-disabled-opacity: var(--sds-checkbox-disabled-opacity, var(--sds-color-states-disabled-opacity));

		--_sds-checkbox-grid-template-areas: var(--sds-checkbox-grid-template-area, 'input content');
		--_sds-checkbox-label-grid-area: var(--sds-checkbox-label-grid-area, content);
		--_sds-checkbox-input-grid-area: var(--sds-checkbox-input-grid-area, input);
		--_sds-checkbox-help-text-grid-area: var(--sds-checkbox-help-text-grid-area, content);

		flex: 0 0 auto;
	}

	.sds-checkbox {
		align-items: start;
		display: grid;
		font-family: var(--_sds-checkbox-font-family);
		gap: var(--_sds-checkbox-block-gap) var(--_sds-checkbox-inline-gap);
		grid-template-areas: var(--_sds-checkbox-grid-template-areas);
		grid-template-columns: auto 1fr;
		width: fit-content;

		&:has(:disabled) {
			cursor: default;
			pointer-events: none;
			opacity: var(--_sds-checkbox-disabled-opacity);
		}

		&:has(:focus-visible) {
			outline: var(--_sds-checkbox-focus-spacing) solid var(--_sds-checkbox-focus-color-outer);
			outline-offset: calc(var(--_sds-checkbox-focus-spacing) * 2);
			border-radius: var(--_sds-checkbox-focus-radius);
		}
	}

	.sds-checkbox--error {
		--_sds-checkbox-label-text-color: var(--sds-checkbox-label-text-color, var(--sds-color-alert-danger-text-default));
	}

	.sds-checkbox__label {
		grid-column: var(--_sds-checkbox-label-grid-area);
		align-self: center;
		cursor: pointer;
		color: var(--_sds-checkbox-label-text-color);
		display: inline-flex;
		font-size: var(--_sds-checkbox-label-font-size);
		font-weight: var(--_sds-checkbox-label-font-weight);
		gap: var(--_sds-checkbox-inline-gap);
		line-height: var(--_sds-checkbox-label-line-height);
	}

	.sds-checkbox__input {
		grid-column: var(--_sds-checkbox-input-grid-area);
		grid-row: 1;
		appearance: none;
		background-color: var(--_sds-checkbox-input-background-color);
		cursor: pointer;
		width: var(--_sds-checkbox-input-size);
		height: var(--_sds-checkbox-input-size);
		aspect-ratio: var(--_sds-checkbox-input-aspect-ratio);
		border-width: var(--_sds-checkbox-input-border-width);
		border-style: var(--_sds-checkbox-input-border-style);
		border-color: var(--_sds-checkbox-input-border-color);
		border-radius: var(--_sds-checkbox-input-border-radius);
		margin: 0;

		&[readonly] {
			--_sds-checkbox-input-background-color: var(--sds-checkbox-input-background-color, var(--sds-color-surface-tinted, var(--sds-color-neutral-surface-tinted)));
			--_sds-checkbox-input-border-color: var(--sds-checkbox-input-border-color, var(--sds-color-border-subtle, var(--sds-color-neutral-border-subtle)));
			cursor: default;
			pointer-events: none;

			& + .sds-checkbox__label {
				cursor: default;
				pointer-events: none;
			}
		}

		&[checked] {
			--_sds-checkbox-input-background-color: var(--sds-checkbox-input-background-color, var(--sds-color-action-default, var(--sds-color-main-action-default)));
			--_sds-checkbox-input-border-color: var(--sds-checkbox-input-border-color, var(--sds-color-action-default, var(--sds-color-main-action-default)));

			&::after {
				content: '';
				position: absolute;
				width: var(--_sds-checkbox-input-size);
				height: var(--_sds-checkbox-input-size);
				background-color: var(--_sds-checkbox-input-icon-color);
				transform-origin: bottom left;
				clip-path: path(
					'M17.7929 6.79302C18.1834 6.40249 18.8164 6.40249 19.2069 6.79302C19.5974 7.18354 19.5974 7.81656 19.2069 8.20708L10.7069 16.7071C10.5194 16.8946 10.2651 17 9.99989 17C9.7347 17 9.48038 16.8946 9.29286 16.7071L4.79286 12.2071C4.40236 11.8166 4.40241 11.1835 4.79286 10.793C5.18338 10.4025 5.81639 10.4025 6.20692 10.793L9.99989 14.586L17.7929 6.79302Z'
				);
				transform: translate(-2px, -2px);
			}

			&[readonly] {
				--_sds-checkbox-input-background-color: var(--sds-checkbox-input-background-color, var(--sds-color-surface-tinted, var(--sds-color-neutral-surface-tinted)));
				--_sds-checkbox-input-border-color: var(--sds-checkbox-input-border-color, var(--sds-color-border-subtle, var(--sds-color-neutral-border-subtle)));
				--_sds-checkbox-input-icon-color: var(--sds-checkbox-input-dot-color, var(--sds-color-action-default, var(--sds-color-neutral-action-default)));
				cursor: default;
				pointer-events: none;
			}
		}

		&:hover {
			--_sds-checkbox-input-border-color: var(--sds-checkbox-input-border-color, var(--sds-color-action-hover, var(--sds-color-main-action-hover)));
		}

		&:active:not([readonly]) {
			--_sds-checkbox-input-border-color: var(--sds-checkbox-input-border-color, var(--sds-color-main-action-active, var(--sds-color-main-action-active)));
		}

		&[checked]:hover {
			--_sds-checkbox-input-background-color: var(--sds-checkbox-input-background-color, var(--sds-color-action-hover, var(--sds-color-main-action-hover)));
			--_sds-checkbox-input-border-color: var(--sds-checkbox-input-border-color, var(--sds-color-action-hover, var(--sds-color-main-action-hover)));
		}

		&[checked]:active:not([readonly]) {
			--_sds-checkbox-input-background-color: var(--sds-checkbox-input-background-color, var(--sds-color-action-active, var(--sds-color-main-action-active)));
			--_sds-checkbox-input-border-color: var(--sds-checkbox-input-border-color, var(--sds-color-action-active, var(--sds-color-main-action-active)));
		}

		&:focus-visible {
			outline: 0;
		}

		&.sds-checkbox__input--error {
			--_sds-checkbox-input-border-color: var(--sds-checkbox-input-border-color, var(--sds-color-alert-danger-border-default));

			&[checked] {
				--_sds-checkbox-input-background-color: var(--sds-checkbox-input-background-color, var(--sds-color-alert-danger-action-default));
				--_sds-checkbox-input-border-color: var(--sds-checkbox-input-border-color, var(--sds-color-alert-danger-action-default));
			}

			&:hover {
				--_sds-checkbox-input-border-color: var(--sds-checkbox-input-border-color, var(--sds-color-alert-danger-action-hover));
			}

			&:active:not([readonly]) {
				--_sds-checkbox-input-border-color: var(--sds-checkbox-input-border-color, var(--sds-color-alert-danger-action-active));
			}

			&[checked]:hover {
				--_sds-checkbox-input-background-color: var(--sds-checkbox-input-background-color, var(--sds-color-alert-danger-action-hover));
				--_sds-checkbox-input-border-color: var(--sds-checkbox-input-border-color, var(--sds-color-alert-danger-action-hover));
			}

			&[checked]:active {
				--_sds-checkbox-input-background-color: var(--sds-checkbox-input-background-color, var(--sds-color-alert-danger-action-active));
				--_sds-checkbox-input-border-color: var(--sds-checkbox-input-border-color, var(--sds-color-alert-danger-action-active));
			}
		}
	}

	.sds-checkbox__help-text {
		grid-column: var(--_sds-checkbox-help-text-grid-area);
		margin: 0;
		color: var(--_sds-checkbox-help-text-color);
		font-size: var(--_sds-checkbox-help-text-font-size);
		font-weight: var(--_sds-checkbox-help-text-font-weight);
		line-height: var(--_sds-checkbox-help-text-line-height);
		max-width: var(--_sds-checkbox-max-line-width);
	}

	:host([size='sm']) {
		--_sds-checkbox-label-font-size: var(--sds-checkbox-label-font-size, var(--sds-components-font-size-content-sm));
		--_sds-checkbox-label-line-height: var(--sds-checkbox-label-line-height, var(--sds-components-line-height-tall-content-sm));
		--_sds-checkbox-input-size: var(--sds-checkbox-input-size, var(--sds-components-icon-sm));

		.sds-checkbox__input:checked::after {
			clip-path: path(
				'M13.168 4.91815C13.5585 4.52763 14.1915 4.52763 14.582 4.91815C14.9724 5.30869 14.9725 5.94173 14.582 6.33221L8.20703 12.7072C8.01952 12.8947 7.76516 13.0002 7.5 13.0002C7.23484 13.0002 6.98049 12.8947 6.79297 12.7072L3.41797 9.33221C3.02746 8.94171 3.0275 8.30868 3.41797 7.91815C3.80849 7.52763 4.44151 7.52763 4.83203 7.91815L7.5 10.5861L13.168 4.91815Z'
			);
		}

		.sds-checkbox__label {
			margin-block-start: 1px;
		}
	}

	:host([size='lg']) {
		--_sds-checkbox-label-font-size: var(--sds-checkbox-label-font-size, var(--sds-components-font-size-content-lg));
		--_sds-checkbox-label-line-height: var(--sds-checkbox-label-line-height, var(--sds-components-line-height-tall-content-lg));
		--_sds-checkbox-input-size: var(--sds-checkbox-input-size, var(--sds-components-icon-lg));

		.sds-checkbox__input:checked::after {
			clip-path: path(
				'M23.9592 9.29327C24.3497 8.9028 24.9828 8.90291 25.3733 9.29327C25.7637 9.68381 25.7638 10.3169 25.3733 10.7073L14.0403 22.0403C13.6498 22.4306 13.0167 22.4307 12.6262 22.0403L6.62622 16.0403C6.23592 15.6499 6.23593 15.0168 6.62622 14.6263C7.0167 14.236 7.6498 14.236 8.04028 14.6263L13.3333 19.9193L23.9592 9.29327Z'
			);
		}

		.sds-checkbox__label {
			margin-block-start: -1px;
		}
	}
`;
